import { render, staticRenderFns } from "./list-share-settings-link.vue?vue&type=template&id=6d493e49&scoped=true&"
import script from "./list-share-settings-link.vue?vue&type=script&lang=ts&"
export * from "./list-share-settings-link.vue?vue&type=script&lang=ts&"
import style0 from "./list-share-settings-link.vue?vue&type=style&index=0&id=6d493e49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d493e49",
  null
  
)

export default component.exports